// extracted by mini-css-extract-plugin
export default {"container":"visit_container__Bopee","header":"visit_header__LYrBZ","back":"visit_back__dD-97","list":"visit_list__3wwpr","rotate":"visit_rotate__32Uqk"};